<template>
  <div class="authorized">
    <el-tabs class="modify-el__tabs" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="item in panel" :label="item.label" :name="item.name" :key="item.name" lazy>
        <SearchComponent ref="search" :condition="condition" @updateData="_updateData" :routeName="$route.name">
          <template #default>
            <div class="input-box">
              <span class="name"> 商品SKU编码： </span>
              <div class="input">
                <el-input v-model="condition.sku" clearable placeholder="请输入" />
              </div>
            </div>
            <div class="input-box">
              <span class="name"> 商品名称： </span>
              <div class="input">
                <el-input v-model="condition.goodsName" clearable placeholder="请输入" />
              </div>
            </div>
            <div class="input-box">
              <span class="name">商品分类：</span>
              <div class="input">
                <el-select v-model="condition.goodsType" placeholder="请选择" clearable>
                  <el-option value="1" label="完税" />
                  <el-option value="2" label="跨境" />
                  <el-option value="3" label="期酒" />
                  <el-option value="5" label="直邮" />
                </el-select>
              </div>
            </div>
            <div class="operator">
              <div class="applets-info">
                <p class="name">
                  {{ $route.query.title }}
                </p>
                <p class="id">ID: {{ $route.query.code }}</p>
              </div>
              <div class="authorized-stock">
                <p class="stock">{{ $route.query.total }}</p>
                <p class="tips">授权总库存</p>
              </div>
            </div>
          </template>
        </SearchComponent>
        <TableComponent ref="table" :btn="false" :tableData="tableData" :routeName="$route.name" @updateData="_updateData"
          :pagination="pagination">
          <template #default="{ handleSelectionChange, changeAuthorizedStatus }">
            <el-table :data="tableData" v-min-height @selection-change="handleSelectionChange"
              header-cell-class-name="theader-th" cell-class-name="tbody-td" :height="500">
              <el-table-column align="center" width="130" type="selection" fixed />
              <el-table-column label="商品标题" align="center" min-width="400">
                <div slot-scope="scope">
                  <el-image :src="scope.row.imgUrl" :preview-src-list="[scope.row.imgUrl]" class="goods-img">
                    <div slot="error" class="image-slot">
                      <i class="iconfont icon-tupian" />
                    </div>
                  </el-image>
                  <div class="caption">
                    <p class="ellipses">
                      <el-tooltip effect="light" placement="bottom-start" :content="scope.row.cnName">
                        <span class="goods-name"> {{ scope.row.cnName }}</span>
                      </el-tooltip>
                    </p>
                    <p class="ellipses">
                      <el-tooltip effect="light" placement="bottom-start" :content="scope.row.enName">
                        <span class="goods-name"> {{ scope.row.enName }}</span>
                      </el-tooltip>
                    </p>
                    <p class="ellipses">
                      <el-tooltip effect="light" placement="bottom-start" :content="scope.row.sku">
                        <span class="goods-name">
                          SKU编码：{{ scope.row.sku }}
                        </span>
                      </el-tooltip>
                    </p>
                  </div>
                </div>
              </el-table-column>
              <el-table-column align="center" label="销售规格" min-width="800">
                <template slot-scope="scope">
                  <div v-for="item in scope.row.specList" :key="item.salesId" style="margin-bottom: 0.3rem">
                    {{ item.salesNum }}
                    支装商品价格
                    {{ item.price | formatMoney }}
                    授权销售价格范围：￥
                    <div class="input" style="display: inline-block; width: 6rem">
                      <el-input v-model="item.startPrice" clearable type="number" placeholder="请输入" :disabled="scope.row.status ||
                        typeof $route.query.details === 'number'
                        " />
                    </div>
                    至
                    <div class="input" style="display: inline-block; width: 6rem">
                      <el-input v-model="item.endPrice" clearable type="number" placeholder="请输入" :disabled="scope.row.status ||
                        typeof $route.query.details === 'number'
                        " />
                    </div>
                    销售价格为：
                    <span class="red">
                      {{ item.salesPrice | formatMoney }}
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="stock" align="center" label="库存" min-width="180" />
              <el-table-column align="center" label="销售状态" min-width="180">
                <template slot-scope="scope">
                  {{ scope.row.salesStatus | formatGoodsState }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="商品类型" min-width="180">
                <template slot-scope="scope">
                  {{ scope.row.type | formatGoodsType }}
                </template>
              </el-table-column>
              <el-table-column prop="time" align="center" label="授权时间" min-width="180" />
              <el-table-column align="center" label="操作" min-width="180" fixed="right">
                <template slot-scope="scope">
                  <input :disabled="$route.query.details" class="mui-switch mui-switch-animbg"
                    @click="changeAuthorizedStatus(scope.row)" v-model="scope.row.status" type="checkbox" />
                </template>
              </el-table-column>
            </el-table>
          </template>
        </TableComponent>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import SearchComponent from '../../Components/SearchComponent'
import TableComponent from '../../Components/TableComponent'
import tabsIndex from 'mixins/tabsIndex'
import updateData from 'mixins/updateData'

export default {
  name: 'authorized',
  mixins: [tabsIndex, updateData],
  components: {
    SearchComponent,
    TableComponent,
  },
  data() {
    this.panel = [
      {
        label: '已授权',
        name: '1',
      },
      {
        label: '未授权',
        name: '2',
      },
    ]
    this.keyMap = {
      goods_list: {
        name: 'tableData',
        add_time: 'time',
        audit_status: 'authorizedStatus',
        authorized_end_price: 'endPrice',
        authorized_start_price: 'startPrice',
        authorized_id: 'authorizedId',
        goods_en: 'enName',
        goods_name: 'cnName',
        goods_image: 'imgUrl',
        goods_sku: 'sku',
        goods_price: 'price',
        goods_id: 'goodsId',
        goods_storage: 'stock',
        merchant_id: 'id',
        spec_list: 'specList',
        sales_quantity: 'salesNum',
        sales_id: 'salesId',
        sales_price: 'salesPrice',
        authorized_inventory: 'authorizedStock',
        goods_state: 'salesStatus',
        goods_type: 'type',
      },
    }
    return {
      activeName: '2',
      condition: {},
      tableData: [],
      pagination: {
        currentPage: 1,
        pageTotal: 19,
        recordTotal: 80,
      },
    }
  },
  watch: {
    $route: {
      handler(to) {
        this.search_model = ['authorized', 'unauthorized']
        this._getGoodsAuthorized({
          curpage: 1,
          merchant_id: to.query.id,
          search_model: this.search_model[+this.activeName - 1],
        })
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 标签页切换
     * @param tab
     * @param event
     */
    handleClick(tab, event) {
      this._getGoodsAuthorized({
        curpage: 1,
        merchant_id: this.$route.query.id,
        search_model: this.search_model[+this.activeName - 1],
      })
      this._tabsRecord()
    },
    /**
     * 获取列表
     * @param params
     * @private
     */
    _getGoodsAuthorized(params) {
      this.api.getAuthorizedList(params).then((res) => {
        this.utils.setCommonCode(res, this)
        this.tableData.forEach((v) => {
          this.$set(v, 'status', this.activeName === '1')
        })
      })
    },
  },
}
</script>
<style lang="scss">
.authorized {
  .input-wrapper {
    position: relative;
    width: calc(100% - 27.5rem);
    margin-right: 1.3rem;
  }

  .operator {
    position: absolute;
    top: 0;
    right: -27.5rem;
    width: 26.2rem;
    height: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;

    .name {
      font-size: 1.3rem;
      font-weight: bold;
      margin-bottom: 0.3rem;
      white-space: nowrap;
    }

    .stock {
      width: 3.8rem;
      height: 3.8rem;
      background-color: colors('bg-sub');
      border-radius: 50%;
      color: #fff;
      margin-bottom: 0.3rem;
      @extend .winner-flex;
    }

    .tips {
      white-space: nowrap;
    }
  }
}
</style>
